"use strict";

var _defineProperty = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _regeneratorRuntime = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/vadim/oskar2/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collection = exports.CollectionStatus = exports.CollectionType = exports.collectionToString = exports.isArangoCollection = void 0;

var cursor_1 = require("./cursor");

var documents_1 = require("./documents");

var error_1 = require("./error");

var indexes_1 = require("./indexes");

var codes_1 = require("./lib/codes");
/**
 * Indicates whether the given value represents an {@link ArangoCollection}.
 *
 * @param collection - A value that might be a collection.
 */


function isArangoCollection(collection) {
  return Boolean(collection && collection.isArangoCollection);
}

exports.isArangoCollection = isArangoCollection;
/**
 * Coerces the given collection name or {@link ArangoCollection} object to
 * a string representing the collection name.
 *
 * @param collection - Collection name or {@link ArangoCollection} object.
 */

function collectionToString(collection) {
  if (isArangoCollection(collection)) {
    return String(collection.name);
  } else return String(collection);
}

exports.collectionToString = collectionToString;
/**
 * Integer values indicating the collection type.
 */

var CollectionType;

(function (CollectionType) {
  CollectionType[CollectionType["DOCUMENT_COLLECTION"] = 2] = "DOCUMENT_COLLECTION";
  CollectionType[CollectionType["EDGE_COLLECTION"] = 3] = "EDGE_COLLECTION";
})(CollectionType = exports.CollectionType || (exports.CollectionType = {}));
/**
 * Integer values indicating the collection loading status.
 */


var CollectionStatus;

(function (CollectionStatus) {
  CollectionStatus[CollectionStatus["NEWBORN"] = 1] = "NEWBORN";
  CollectionStatus[CollectionStatus["UNLOADED"] = 2] = "UNLOADED";
  CollectionStatus[CollectionStatus["LOADED"] = 3] = "LOADED";
  CollectionStatus[CollectionStatus["UNLOADING"] = 4] = "UNLOADING";
  CollectionStatus[CollectionStatus["DELETED"] = 5] = "DELETED";
  CollectionStatus[CollectionStatus["LOADING"] = 6] = "LOADING";
})(CollectionStatus = exports.CollectionStatus || (exports.CollectionStatus = {}));
/**
 * @internal
 * @hidden
 */


var Collection = /*#__PURE__*/function () {
  //#endregion

  /**
   * @internal
   * @hidden
   */
  function Collection(db, name) {
    _classCallCheck(this, Collection);

    this._name = name;
    this._db = db;
  } //#region internals


  _createClass(Collection, [{
    key: "_get",
    value: function _get(path, qs) {
      return this._db.request({
        path: "/_api/collection/".concat(this._name, "/").concat(path),
        qs: qs
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "_put",
    value: function _put(path, body) {
      return this._db.request({
        method: "PUT",
        path: "/_api/collection/".concat(this._name, "/").concat(path),
        body: body
      }, function (res) {
        return res.body;
      });
    } //#endregion
    //#region metadata

  }, {
    key: "isArangoCollection",
    get: function get() {
      return true;
    }
  }, {
    key: "name",
    get: function get() {
      return this._name;
    }
  }, {
    key: "get",
    value: function get() {
      return this._db.request({
        path: "/_api/collection/".concat(this._name)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "exists",
    value: function () {
      var _exists = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.get();

              case 3:
                return _context.abrupt("return", true);

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                if (!(error_1.isArangoError(_context.t0) && _context.t0.errorNum === codes_1.COLLECTION_NOT_FOUND)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", false);

              case 10:
                throw _context.t0;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function exists() {
        return _exists.apply(this, arguments);
      }

      return exists;
    }()
  }, {
    key: "create",
    value: function create(options) {
      var _ref = options || {},
          _ref$waitForSyncRepli = _ref.waitForSyncReplication,
          waitForSyncReplication = _ref$waitForSyncRepli === void 0 ? undefined : _ref$waitForSyncRepli,
          _ref$enforceReplicati = _ref.enforceReplicationFactor,
          enforceReplicationFactor = _ref$enforceReplicati === void 0 ? undefined : _ref$enforceReplicati,
          opts = _objectWithoutProperties(_ref, ["waitForSyncReplication", "enforceReplicationFactor"]);

      var qs = {};

      if (typeof waitForSyncReplication === "boolean") {
        qs.waitForSyncReplication = waitForSyncReplication ? 1 : 0;
      }

      if (typeof enforceReplicationFactor === "boolean") {
        qs.enforceReplicationFactor = enforceReplicationFactor ? 1 : 0;
      }

      return this._db.request({
        method: "POST",
        path: "/_api/collection",
        qs: qs,
        body: _objectSpread(_objectSpread({}, opts), {}, {
          name: this.name
        })
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "properties",
    value: function properties(_properties) {
      if (!_properties) return this._get("properties");
      return this._put("properties", _properties);
    }
  }, {
    key: "count",
    value: function count() {
      return this._get("count");
    }
  }, {
    key: "recalculateCount",
    value: function () {
      var _recalculateCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var body;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._put("recalculateCount");

              case 2:
                body = _context2.sent;
                return _context2.abrupt("return", body.result);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function recalculateCount() {
        return _recalculateCount.apply(this, arguments);
      }

      return recalculateCount;
    }()
  }, {
    key: "figures",
    value: function figures() {
      return this._get("figures");
    }
  }, {
    key: "revision",
    value: function revision() {
      return this._get("revision");
    }
  }, {
    key: "checksum",
    value: function checksum(options) {
      return this._get("checksum", options);
    }
  }, {
    key: "load",
    value: function load(count) {
      return this._put("load", typeof count === "boolean" ? {
        count: count
      } : undefined);
    }
  }, {
    key: "loadIndexes",
    value: function () {
      var _loadIndexes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var body;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._put("loadIndexesIntoMemory");

              case 2:
                body = _context3.sent;
                return _context3.abrupt("return", body.result);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loadIndexes() {
        return _loadIndexes.apply(this, arguments);
      }

      return loadIndexes;
    }()
  }, {
    key: "unload",
    value: function unload() {
      return this._put("unload");
    }
  }, {
    key: "rename",
    value: function () {
      var _rename = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(newName) {
        var result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._db.renameCollection(this._name, newName);

              case 2:
                result = _context4.sent;
                this._name = newName;
                return _context4.abrupt("return", result);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function rename(_x) {
        return _rename.apply(this, arguments);
      }

      return rename;
    }()
  }, {
    key: "rotate",
    value: function () {
      var _rotate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var body;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._put("rotate");

              case 2:
                body = _context5.sent;
                return _context5.abrupt("return", body.result);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function rotate() {
        return _rotate.apply(this, arguments);
      }

      return rotate;
    }()
  }, {
    key: "truncate",
    value: function truncate() {
      return this._put("truncate");
    }
  }, {
    key: "drop",
    value: function drop(options) {
      return this._db.request({
        method: "DELETE",
        path: "/_api/collection/".concat(this._name),
        qs: options
      }, function (res) {
        return res.body;
      });
    } //#endregion
    //#region crud

  }, {
    key: "getResponsibleShard",
    value: function getResponsibleShard(document) {
      return this._db.request({
        method: "PUT",
        path: "/_api/collection/".concat(this.name, "/responsibleShard"),
        body: document
      }, function (res) {
        return res.body.shardId;
      });
    }
  }, {
    key: "documentId",
    value: function documentId(selector) {
      return documents_1._documentHandle(selector, this._name);
    }
  }, {
    key: "documentExists",
    value: function () {
      var _documentExists = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(selector) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this._db.request({
                  method: "HEAD",
                  path: "/_api/document/".concat(documents_1._documentHandle(selector, this._name))
                }, function () {
                  return true;
                });

              case 3:
                return _context6.abrupt("return", _context6.sent);

              case 6:
                _context6.prev = 6;
                _context6.t0 = _context6["catch"](0);

                if (!(_context6.t0.code === 404)) {
                  _context6.next = 10;
                  break;
                }

                return _context6.abrupt("return", false);

              case 10:
                throw _context6.t0;

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 6]]);
      }));

      function documentExists(_x2) {
        return _documentExists.apply(this, arguments);
      }

      return documentExists;
    }()
  }, {
    key: "document",
    value: function () {
      var _document = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(selector) {
        var options,
            _options,
            _options$allowDirtyRe,
            allowDirtyRead,
            _options$graceful,
            graceful,
            result,
            _args7 = arguments;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                options = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};

                if (typeof options === "boolean") {
                  options = {
                    graceful: options
                  };
                }

                _options = options, _options$allowDirtyRe = _options.allowDirtyRead, allowDirtyRead = _options$allowDirtyRe === void 0 ? undefined : _options$allowDirtyRe, _options$graceful = _options.graceful, graceful = _options$graceful === void 0 ? false : _options$graceful;
                result = this._db.request({
                  path: "/_api/document/".concat(documents_1._documentHandle(selector, this._name)),
                  allowDirtyRead: allowDirtyRead
                }, function (res) {
                  return res.body;
                });

                if (graceful) {
                  _context7.next = 6;
                  break;
                }

                return _context7.abrupt("return", result);

              case 6:
                _context7.prev = 6;
                _context7.next = 9;
                return result;

              case 9:
                return _context7.abrupt("return", _context7.sent);

              case 12:
                _context7.prev = 12;
                _context7.t0 = _context7["catch"](6);

                if (!(error_1.isArangoError(_context7.t0) && _context7.t0.errorNum === codes_1.DOCUMENT_NOT_FOUND)) {
                  _context7.next = 16;
                  break;
                }

                return _context7.abrupt("return", null);

              case 16:
                throw _context7.t0;

              case 17:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[6, 12]]);
      }));

      function document(_x3) {
        return _document.apply(this, arguments);
      }

      return document;
    }()
  }, {
    key: "save",
    value: function save(data, options) {
      return this._db.request({
        method: "POST",
        path: "/_api/document/".concat(this._name),
        body: data,
        qs: options
      }, function (res) {
        return options && options.silent ? undefined : res.body;
      });
    }
  }, {
    key: "saveAll",
    value: function saveAll(data, options) {
      return this._db.request({
        method: "POST",
        path: "/_api/document/".concat(this._name),
        body: data,
        qs: options
      }, function (res) {
        return options && options.silent ? undefined : res.body;
      });
    }
  }, {
    key: "replace",
    value: function replace(selector, newData, options) {
      return this._db.request({
        method: "PUT",
        path: "/_api/document/".concat(documents_1._documentHandle(selector, this._name)),
        body: newData,
        qs: options
      }, function (res) {
        return options && options.silent ? undefined : res.body;
      });
    }
  }, {
    key: "replaceAll",
    value: function replaceAll(newData, options) {
      return this._db.request({
        method: "PUT",
        path: "/_api/document/".concat(this._name),
        body: newData,
        qs: options
      }, function (res) {
        return options && options.silent ? undefined : res.body;
      });
    }
  }, {
    key: "update",
    value: function update(selector, newData, options) {
      return this._db.request({
        method: "PATCH",
        path: "/_api/document/".concat(documents_1._documentHandle(selector, this._name)),
        body: newData,
        qs: options
      }, function (res) {
        return options && options.silent ? undefined : res.body;
      });
    }
  }, {
    key: "updateAll",
    value: function updateAll(newData, options) {
      return this._db.request({
        method: "PATCH",
        path: "/_api/document/".concat(this._name),
        body: newData,
        qs: options
      }, function (res) {
        return options && options.silent ? undefined : res.body;
      });
    }
  }, {
    key: "remove",
    value: function remove(selector, options) {
      return this._db.request({
        method: "DELETE",
        path: "/_api/document/".concat(documents_1._documentHandle(selector, this._name)),
        qs: options
      }, function (res) {
        return options && options.silent ? undefined : res.body;
      });
    }
  }, {
    key: "removeAll",
    value: function removeAll(selectors, options) {
      var _this = this;

      return this._db.request({
        method: "DELETE",
        path: "/_api/document/".concat(this._name),
        body: selectors.map(function (selector) {
          return documents_1._documentHandle(selector, _this._name);
        }),
        qs: options
      }, function (res) {
        return options && options.silent ? undefined : res.body;
      });
    }
  }, {
    key: "import",
    value: function _import(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var qs = _objectSpread(_objectSpread({}, options), {}, {
        collection: this._name
      });

      if (Array.isArray(data)) {
        qs.type = Array.isArray(data[0]) ? undefined : "documents";
        var lines = data;
        data = lines.map(function (line) {
          return JSON.stringify(line);
        }).join("\r\n") + "\r\n";
      }

      return this._db.request({
        method: "POST",
        path: "/_api/import",
        body: data,
        isBinary: true,
        qs: qs
      }, function (res) {
        return res.body;
      });
    } //#endregion
    //#region edges

  }, {
    key: "_edges",
    value: function _edges(selector, direction) {
      return this._db.request({
        path: "/_api/edges/".concat(this._name),
        qs: {
          direction: direction,
          vertex: documents_1._documentHandle(selector, this._name, false)
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "edges",
    value: function edges(vertex) {
      return this._edges(vertex);
    }
  }, {
    key: "inEdges",
    value: function inEdges(vertex) {
      return this._edges(vertex, "in");
    }
  }, {
    key: "outEdges",
    value: function outEdges(vertex) {
      return this._edges(vertex, "out");
    }
  }, {
    key: "traversal",
    value: function traversal(startVertex, options) {
      return this._db.request({
        method: "POST",
        path: "/_api/traversal",
        body: _objectSpread(_objectSpread({}, options), {}, {
          startVertex: startVertex,
          edgeCollection: this._name
        })
      }, function (res) {
        return res.body.result;
      });
    } //#endregion
    //#region simple queries

  }, {
    key: "list",
    value: function list() {
      var _this2 = this;

      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "id";
      return this._db.request({
        method: "PUT",
        path: "/_api/simple/all-keys",
        body: {
          type: type,
          collection: this._name
        }
      }, function (res) {
        return new cursor_1.BatchedArrayCursor(_this2._db, res.body, res.arangojsHostId).items;
      });
    }
  }, {
    key: "all",
    value: function all(options) {
      var _this3 = this;

      return this._db.request({
        method: "PUT",
        path: "/_api/simple/all",
        body: _objectSpread(_objectSpread({}, options), {}, {
          collection: this._name
        })
      }, function (res) {
        return new cursor_1.BatchedArrayCursor(_this3._db, res.body, res.arangojsHostId).items;
      });
    }
  }, {
    key: "any",
    value: function any() {
      return this._db.request({
        method: "PUT",
        path: "/_api/simple/any",
        body: {
          collection: this._name
        }
      }, function (res) {
        return res.body.document;
      });
    }
  }, {
    key: "byExample",
    value: function byExample(example, options) {
      var _this4 = this;

      return this._db.request({
        method: "PUT",
        path: "/_api/simple/by-example",
        body: _objectSpread(_objectSpread({}, options), {}, {
          example: example,
          collection: this._name
        })
      }, function (res) {
        return new cursor_1.BatchedArrayCursor(_this4._db, res.body, res.arangojsHostId).items;
      });
    }
  }, {
    key: "firstExample",
    value: function firstExample(example) {
      return this._db.request({
        method: "PUT",
        path: "/_api/simple/first-example",
        body: {
          example: example,
          collection: this._name
        }
      }, function (res) {
        return res.body.document;
      });
    }
  }, {
    key: "removeByExample",
    value: function removeByExample(example, options) {
      return this._db.request({
        method: "PUT",
        path: "/_api/simple/remove-by-example",
        body: _objectSpread(_objectSpread({}, options), {}, {
          example: example,
          collection: this._name
        })
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "replaceByExample",
    value: function replaceByExample(example, newValue, options) {
      return this._db.request({
        method: "PUT",
        path: "/_api/simple/replace-by-example",
        body: _objectSpread(_objectSpread({}, options), {}, {
          example: example,
          newValue: newValue,
          collection: this._name
        })
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "updateByExample",
    value: function updateByExample(example, newValue, options) {
      return this._db.request({
        method: "PUT",
        path: "/_api/simple/update-by-example",
        body: _objectSpread(_objectSpread({}, options), {}, {
          example: example,
          newValue: newValue,
          collection: this._name
        })
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "lookupByKeys",
    value: function lookupByKeys(keys) {
      return this._db.request({
        method: "PUT",
        path: "/_api/simple/lookup-by-keys",
        body: {
          keys: keys,
          collection: this._name
        }
      }, function (res) {
        return res.body.documents;
      });
    }
  }, {
    key: "removeByKeys",
    value: function removeByKeys(keys, options) {
      return this._db.request({
        method: "PUT",
        path: "/_api/simple/remove-by-keys",
        body: {
          options: options,
          keys: keys,
          collection: this._name
        }
      }, function (res) {
        return res.body;
      });
    } //#endregion
    //#region indexes

  }, {
    key: "indexes",
    value: function indexes() {
      return this._db.request({
        path: "/_api/index",
        qs: {
          collection: this._name
        }
      }, function (res) {
        return res.body.indexes;
      });
    }
  }, {
    key: "index",
    value: function index(selector) {
      return this._db.request({
        path: "/_api/index/".concat(indexes_1._indexHandle(selector, this._name))
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "ensureIndex",
    value: function ensureIndex(options) {
      return this._db.request({
        method: "POST",
        path: "/_api/index",
        body: options,
        qs: {
          collection: this._name
        }
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "dropIndex",
    value: function dropIndex(selector) {
      return this._db.request({
        method: "DELETE",
        path: "/_api/index/".concat(indexes_1._indexHandle(selector, this._name))
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "fulltext",
    value: function fulltext(attribute, query) {
      var _this5 = this;

      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          index = _ref2.index,
          options = _objectWithoutProperties(_ref2, ["index"]);

      return this._db.request({
        method: "PUT",
        path: "/_api/simple/fulltext",
        body: _objectSpread(_objectSpread({}, options), {}, {
          index: index ? indexes_1._indexHandle(index, this._name) : undefined,
          attribute: attribute,
          query: query,
          collection: this._name
        })
      }, function (res) {
        return new cursor_1.BatchedArrayCursor(_this5._db, res.body, res.arangojsHostId).items;
      });
    }
  }]);

  return Collection;
}();

exports.Collection = Collection;